<template>
  <div class="mt-8">
    <div class="intro-y box p-5 mt-5">
      <div class="flex items-center h-10">
        <h2 class="text-lg font-bold truncate mr-5">三年租金计划</h2>
        <div class="ml-auto">
          <el-button @click="exportHandle" type="primary">导出表格</el-button>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                2022租金计划收入
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{firstYearContractRent}}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                2023租金计划收入
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{secondYearContractRent }}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5" style="min-height:160px;">
            <div class="flex">
              <div>
                2024租金计划收入
              </div>
              <div class="ml-auto">
              </div>
            </div>
            <div class="text-2xl font-bold leading-8 mt-4">{{thirdYearContractRent }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y mt-8">
      <div class="intro-y box p-5 mt-5" style='padding-bottom: 0;'>
        <el-form :form="form" inline>
          <el-form-item label="资产出租地址明细:">
            <el-input v-model='form.assetAddressDetail' placeholder="请输入资产出租地址明细" clearable/>
          </el-form-item>
          <el-form-item label="合同编号:">
            <el-input v-model='form.contractNo' placeholder="请输入合同编号" clearable/>
          </el-form-item>
          <el-form-item label="合同日期:">
            <el-date-picker
              v-model="form.contractStartDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <span style="padding:0 10px;">至</span>
            <el-date-picker
              v-model="form.contractEndDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type='primary'  @click="searchHandle"> 搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table begin-->
      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report mt-2">
          <thead>
          <tr class="text-gray-700">
            <th class="text-center whitespace-no-wrap">资产出租地址明细</th>
            <th class="text-center whitespace-no-wrap">面积</th>
            <th class="text-center whitespace-no-wrap">原租户</th>
            <th class="text-center whitespace-no-wrap">原租期</th>
            <th class="text-center whitespace-no-wrap">原合同年租金</th>
            <th class="text-center whitespace-no-wrap">2022计划租金</th>
            <th class="text-center whitespace-no-wrap">2023计划租金</th>
            <th class="text-center whitespace-no-wrap">2024计划租金</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(faker, fakerKey) in datas"
              :key="fakerKey"
              class="intro-x"
          >
            <td class="border-b dark:border-dark-5">
              {{ faker.assetAddressDetail }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.buildingArea }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.lessee }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.contractStartDate }}~{{faker.contractEndDate}}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.annualContractRent }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.firstYearContractRent }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.secondYearContractRent }}
            </td>
            <td class="border-b dark:border-dark-5">
              {{ faker.thirdYearContractRent }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- table end -->
      <!-- BEGIN: Pagination -->

      <!-- END: Pagination -->
    </div>
    <div class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
         style='justify-content: space-between'>
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size='form.perPage'
          :current-page='form.page'
          @current-change='handleTableChange'
          :total="total">
      </el-pagination>
      <select class="border w-20 input box mt-3 sm:mt-0" @change="pageSizeChange">
        <option>10</option>
        <option>25</option>
        <option>35</option>
        <option>50</option>
      </select>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  getRentalPlanList,
  getRentalTotal,
  downRentalPlanList
} from '@/api/workbench.js'
import {downFile,outputdollars} from '@/assets/js/tools.js'
export default {
  data() {
    return {
      loadingCheck: false,
      loadingSearch: false,
      staticData: {},
      firstYearContractRent:'',
      secondYearContractRent:'',
      thirdYearContractRent:'',
      form: {
        assetAddress:'',
        contractNo:'',
        assetAddressDetail:'',
        contractStartDate:'',
        contractEndDate:'',
        page: 1,
        perPage: 10,
      },
      total: 0,
      sourceOptions: [
        {value:'',key:'请选择'},
        {value: '托管', key: '托管'},
        {value: '不填报', key: '不填报'},
        {value: '租转', key: '租转'},
        {value: '集团公司', key: '集团公司'},
        {value: '自有', key: '自有'},
        {value: '国资委', key: '国资委'},
      ],
      statusOptions: [
        {value:'',key:'请选择'},
        {value: '0', key: '未出租'},
        {value: '1', key: '已出租'},
      ],
      datas: [],
    }
  },
  methods: {
    onChange(val) {
      this.form.companyId = val[val.length - 1]
    },
    exportHandle(){
       downRentalPlanList(this.form).then(res=>{
        downFile(res)
       })
    },
    getStatic() {
      this.loadingCheck = true;
      getRentalTotal().then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.staticData = data.content;
          this.firstYearContractRent = outputdollars(this.staticData.firstYearContractRent)
          this.secondYearContractRent = outputdollars(this.staticData.secondYearContractRent)
          this.thirdYearContractRent = outputdollars(this.staticData.thirdYearContractRent)
          this.loadingCheck = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    initList() {
      this.loadingSearch = true;
      this.form.userId = this.$route.query.userId;
      getRentalPlanList(this.form).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.datas = data.content.list;
          this.total = data.content.total;
          this.loadingSearch = false;
        } else {
          console.log(data.desc)
        }
      })
    },
    searchHandle() {
      this.form.page = 1;
      this.initList();
    },
    handleTableChange(page) {
      this.form.page = page;
      this.initList();
    },
    pageSizeChange(e) {
      this.form.page = 1;
      this.form.perPage = Number(e.target.value);
      this.initList();
    },
    checkHandle(val) {
      let url=this.$router.resolve({path: '/assetManagement/assetDetail', query: {assetId: val.assetId}}).href
      window.open(url)
    },
  },
  created() {
    this.initList();
    this.getStatic();
  }
};
</script>

